'use client';

import ReactDOM from 'react-dom';

export default function PetAvatarsPreconnect() {
  // Preconnect к CDN с аватарками питомцев
  ReactDOM.preconnect('https://petavatars-20f98.kxcdn.com', {
    crossOrigin: 'anonymous'
  });

  // DNS-prefetch для того же хоста
  ReactDOM.prefetchDNS('https://petavatars-20f98.kxcdn.com');

  return null;
}
